import { WarningCircle, ArrowClockwise } from "@phosphor-icons/react";

const VideoErrorBox = ({ reset }: { reset: () => void }) => (
  <div className="flex flex-col items-center justify-center h-full">
    <div className="bg-surface-1 border border-white/[0.08] max-w-xs px-8 pt-8 pb-6 rounded-2xl text-center">
      <div className="w-14 h-14 rounded-full bg-myRose/10 flex items-center justify-center mx-auto mb-4">
        <WarningCircle size={28} className="text-myRose" weight="duotone" />
      </div>
      <p className="text-base text-white font-semibold mb-1">
        Video yüklenemedi
      </p>
      <p className="text-sm text-white/40 leading-relaxed mb-5">
        Sorun devam ederse lütfen bize bildirin.
      </p>
      <button
        onClick={reset}
        className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/[0.08] text-white text-sm font-medium rounded-xl transition-colors cursor-pointer"
      >
        <ArrowClockwise size={16} weight="bold" />
        Yeniden Dene
      </button>
    </div>
  </div>
);

export default VideoErrorBox;
